<template>
  <div class="notification-list">
    <template>
      <div :class="[notificationMultiple ? 'notification-list__multiple' : 'notification-list__single']">
        <notification-card class="flex-item" v-for="(notification, idx) in notificationList" :key="idx"
          :notification="notification" />
      </div>
    </template>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <template #no-results>
        <span
          v-html="$te('AppTranslations.EmptyNotifications') ? $t('AppTranslations.EmptyNotifications') : 'No notifications found'" />
        <br />
      </template>
      <template #no-more />
    </infinite-loading>
  </div>
</template>

<script>
import notificationCard from './notificationCard.vue'
import dayjs from 'dayjs'
import { mapActions, mapGetters } from 'vuex'

export default {
  inheritAttrs: false,
  props: {
    notificationMultiple: {
      type: Boolean,
      default: true,
    },
  },
  components: { notificationCard },
  data() {
    return {
      notificationList: [],
      listOffset: 0,
      listItemPerPage: 20,
      infiniteId: 0,
      initialized: false,
      notificationResult:[]
    }
  },
   computed: {
    ...mapGetters({
      getPushnotifications: 'pushnotifications/pushnotification',
    }),
  },
  methods: {
     ...mapActions({
      loadNotifications: 'pushnotifications/loadPushnotification',
    }),
      async getNotifications(){
      if(this.getPushnotifications){
        const notificationsUnsorted  =  this.getPushnotifications.filter((a) => dayjs() >= dayjs(a.displayFromDate))
        this.notificationResult = notificationsUnsorted.sort((a, b) => { 
            if(dayjs(a.displayFromDate) > dayjs(b.displayFromDate)) {
              return -1
            }
            if(dayjs(a.displayFromDate) < dayjs(b.displayFromDate)){
              return 1
            }
            return 0

          })
      }
    },
    async infiniteHandler($state) {
      const data = this.notificationResult.slice(
        this.listOffset,
        this.listOffset + this.listItemPerPage,
      )
      this.listOffset += this.listItemPerPage
      if (data.length) {
        this.notificationList.push(...data)
        $state.loaded()
        this.initialized = true
      } else {
        $state.complete()
        this.initialized = true
      }
      localStorage.setItem('notificationList', JSON.stringify(this.getPushnotifications))
    },
  },
  watch: {
    notificationResult() {
      this.notificationList = []
      this.infiniteId += 1
      this.listOffset = 0
      this.listLoaded = true
    },
  },
  async mounted(){
    await this.loadNotifications()
    await this.getNotifications()
  },
}
</script>
<style lang="scss" scoped>

  .notification-list {
    flex-direction: column;
    display: flex;
    /* box-shadow: var(--pag-box-shadow);
    background: var(--pag-box-background); */
    /* margin: var(--pag-box-margin); */
    gap: var(--pag-box-gap);
  }

.notification-list__single {
    display: grid;
    grid-template-columns: repeat(1, minmax(100px, 1fr));
    grid-gap: 1.25rem;
    }

    .notification-list__multiple {
    display: grid;
    grid-template-columns: repeat(3, minmax(100px, 1fr));

    grid-gap: 1.25rem;
    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, minmax(100px, 1fr));
    }
    @media (max-width: 768px) {
        grid-template-columns: repeat(1, minmax(100px, 1fr));
    }
    }

</style>